module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card",
    class: {
      'el-card--wide': _vm.wide
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5fc7aea","hasScoped":false}!./src/app/components/card/card.html
// module id = 3103
// module chunks = 1